import { createContext, ReactNode, useContext } from 'react'
import type { StampAnnotation } from '@st/sdk'

type User = {
  id: string
  name?: string
  email?: string
}

type AnnotationsContextState = {
  currentUser: User | undefined
  users: User[]
  stampAnnotations: StampAnnotation[]
  crossReferenceNavigation: CrossReferenceNavigation
}

type CrossReferenceNavigation = {
  previous?: () => void
  next?: () => void
}

const AnnotationsContext = createContext<AnnotationsContextState | undefined>(undefined)

type Props = {
  children: ReactNode
  currentUser: User | undefined
  users: User[]
  stampAnnotations: StampAnnotation[]
  crossReferenceNavigation: AnnotationsContextState['crossReferenceNavigation']
}
export function AnnotationsProvider({
  children,
  currentUser,
  users,
  stampAnnotations,
  crossReferenceNavigation
}: Props) {
  return (
    <AnnotationsContext.Provider
      value={{
        currentUser,
        users,
        stampAnnotations,
        crossReferenceNavigation
      }}
    >
      {children}
    </AnnotationsContext.Provider>
  )
}

export function useAnnotationsContext(): AnnotationsContextState {
  const context = useContext(AnnotationsContext)
  if (context === undefined) {
    throw new Error('You must have an AnnotationsProvider which provides currentUser')
  }
  return context
}
